import { escapeAttr, escapeHtml } from "../utils/html.js";
import { t } from "../../../../shared/i18n/index.js";

/**
 * Focus-path breadcrumbs: plain "x › y › z" text, tap a crumb to refocus.
 * Shared by the outline, mindmap and bubble tabs so focus context looks and
 * behaves the same everywhere.
 *
 * @param {Object} appState - Store state
 * @param {Object} callbacks - mobile callbacks (needs Store.getPath)
 * @param {Object} [opts]
 * @param {boolean} [opts.bare=false] - emit only the crumbs, no strip wrapper
 *   (for embedding inside an existing toolbar row)
 */
export function renderFocusCrumbs(appState, callbacks, opts = {}) {
  const root = appState.data;
  if (!root) return "";
  const path = callbacks.Store.getPath?.(appState.focusId) || [];
  const entries = path.length ? path : [root];
  const crumbs = entries
    .map((node, i) => {
      const isLast = i === entries.length - 1;
      return `${i > 0 ? '<span class="mobile-crumb-sep-text" aria-hidden="true">›</span>' : ""}
        <button class="mobile-crumb ${isLast ? "current" : ""}"
                data-mobile-action="focus-node"
                data-node-id="${escapeAttr(node.id)}">${escapeHtml(node.name || t("views.root"))}</button>`;
    })
    .join("");
  if (opts.bare) return crumbs;
  return `<div class="mobile-focus-strip">${crumbs}</div>`;
}
